import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b7d0ee3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "section",
  style: {"position":"relative","top":"96px"}
}
const _hoisted_2 = { class: "section-div" }
const _hoisted_3 = { class: "row section-p3" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "da" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "section-div-div" }
const _hoisted_8 = { class: "section-div-div-p1" }
const _hoisted_9 = { class: "section-div-div-p2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row section-div-div-p3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "heng" }),
  /*#__PURE__*/_createElementVNode("p", { class: "zi" }, "MORE")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsData, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-md-4",
            key: index,
            onClick: ($event: any) => (_ctx.goLink(item.id,  item.title))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: 
                  _ctx.url +
                  '/' +
                  item.pictureObj.filePath +
                  '/' +
                  item.pictureObj.id +
                  item.pictureObj.suffix
                
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", null, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(item.title), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(item.summary), 1),
                _hoisted_10
              ])
            ])
          ], 8, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}